import { Component }        from '@angular/core';
import { DialogService } from 'source/app/controls/services/dialog/dialog-service';
import { AlertDialog } from 'source/app/controls/services/dialog/alert-dialog';
import { ConfirmDialog } from 'source/app/controls/services/dialog/confirm-dialog';


@Component({
  templateUrl: './modals.html'
})
export class ModalsComponent { 

    constructor(private dialog: DialogService) { }

    OpenAlertModal()
    {
      AlertDialog.Show("Alert", "Alert Content!");
    }

    OpenConfirmModal()
    {
      ConfirmDialog.Show("Confirm", "Confirm Content?");
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/modals/modals-component.ts